<template>
	<div>
		<div class="evidence-info">
			<div class="evidence-info-head">
				<div class="row">
					<div class="col-xs-12 evidence-info-name" title="Motorista da rota">
						{{ (delivery.driver_name ? delivery.driver_name : delivery.name) }}
					</div>
					<div class="col-xs-4 evidence-info-summary" title="Entrega">
						<div class="evidence-info-summary-icon"><i class="fa fa-fw fa-box"></i></div>
						<div class="evidence-info-summary-label">{{ delivery.document_number }}</div>
					</div>
					<div class="col-xs-4 evidence-info-summary" title="Veículo utilizado">
						<div class="evidence-info-summary-icon"><i class="fa fa-fw fa-truck"></i></div>
						<div class="evidence-info-summary-label">{{ delivery.license_plate ? delivery.license_plate : "Não definido"}}</div>
					</div>
					<div class="col-xs-4 evidence-info-summary" title="Carga">
						<div class="evidence-info-summary-icon"><i class="fa fa-fw fa-boxes"></i></div>
						<div class="evidence-info-summary-label">{{ delivery.cargo ? delivery.cargo : "Não definida" }}</div>
					</div>
				</div>
			</div>
			<div class="evidence-info-body evidence-info-body-tab-block">
				<div v-for="(evidence, index) in evidences" :key="index" class="col-lg-12 evidence-item">
					<div v-if="evidence.exist_file" class="row">
						<div class="col-xs-4 col-lg-4" @click="onClick(evidence.id, evidence.location)">
							<div class="evidence-info-image">
								<span class="evidence-info-image-img">
									<img :src="evidence.thumb" />
								</span>
							</div>
						</div>
						<div class="col-xs-8 col-lg-8">
							<div class="evidence-info-item">
								<div class="evidence-info-left">
									<span v-if="evidence.type == 'image'"><i class="fas fa-fw fa-camera"></i> Foto</span>
									<span v-else><i class="fas fa-fw fa-video"></i> Vídeo</span>
								</div>
								<div class="evidence-info-right">{{ evidence.date }}</div>
							</div>
							<div class="evidence-info-item">
								<div v-if="evidence.location != null" class="evidence-info-left">
									<button class="button-location" @click="onClick(evidence.id, evidence.location)"><i class="fas fa-fw fa-dot-circle"></i> Ver posição</button>
								</div>
								<div class="evidence-info-right">
									<button class="button-download" @click="download(evidence.src, evidence.filename)"><i class="fas fa-fw fa-download"></i> Download</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="control control-delivery" @click="onClickDelivery()" title="Localização de entrega">
			<i class="fas fa-fw fa-map-marker-alt"></i>
		</div>
		<div class="map" ref="map"></div>
	</div>
</template>

<script>
import GoogleMapsApiLoader from 'google-maps-api-loader';

const status = {
	waiting: {
		url: require("@/assets/yellow_marker2.svg"),
		color: "#ffb300",
		status: "Aguardando",
	},
	in_progress: {
		url: require("@/assets/blue_marker2.svg"),
		color: "#005ef7",
		status: "A caminho",
	},
	finished: {
		url: require("@/assets/green_marker2.svg"),
		color: "#008000",
		status: "Finalizado",
	},
	failed: {
		url: require("@/assets/red_marker2.svg"),
		color: "#ff0000",
		status: "Não entregue",
	},
	untracked: {
		url: require("@/assets/gray_light_marker3.svg"),
		color: "#aaa",
		status: "Desvinculado",
	},
};

const evidence_marker = require("@/assets/app_marker.svg");

export default {
	name: "EvidenceGoogleMaps",

	props: {
		delivery: {
			type: Object,
			require: true,
		},
		evidences: {
			type: Array,
			require: true,
		},
	},

	data: function() {
		let center = "0,0";
		if (this.delivery.coordinates) center = this.delivery.coordinates;
		return {
			google: null,
			map: null,
			center: {
				lat: parseFloat(center.split(",")[0]),
				lng: parseFloat(center.split(",")[1]),
			},
			zoom: 13,
		}
	},

	mounted: function() {
		this.start();
	},
	
	methods: {
		/**
		 * Inicia a API do Google
		 **/
        start: async function() {
			// Carrega a API do Google Map
			this.google = await GoogleMapsApiLoader({
				apiKey: this.$api.config.B2B_GOOLE_API_KEY
			});

			// Inicia a exibição do mapa
			this.initializeMap();
			this.createDeliveryPositionMarker();
			this.createEvidencePositionMarker();
		},

		/**
		 * Gera o mapa com os marcadores no modal
		 **/
        initializeMap: async function() {
			// Cria o mapa
			let map = new this.google.maps.Map(this.$refs.map, {
				center: {
					lat: this.center.lat,
					lng: this.center.lng,
				},
				backgroundColor: "#fefefe",
				draggable: true,
				zoom: 16,
				zoomControl: true,
				zoomControlOptions: {
					position: this.google.maps.ControlPosition.RIGHT_BOTTOM,
				},
				streetViewControl: false,
				mapTypeControl: false,
				fullscreenControl: false,
				styles: [
					{
						featureType: "poi",
						stylers: [{
							visibility: "off",
						}],
					},{
						featureType: "transit",
						elementType: "labels.icon",
						stylers: [{
							visibility: "off",
						}],
					},
				],
			});

			// Define o objeto do mapa
            this.map = map;
        },

		/**
		 * Adiciona o marcador do ponto de entrega
		 **/
        createDeliveryPositionMarker: function() {
            // Determina o marcador da posiçaõ do APP e coloca no mapa
            let marker = new this.google.maps.Marker({
                position: {
                    lat: this.center.lat,
                    lng: this.center.lng,
                },
                map: this.map,
                icon: {
                    url: status[this.delivery.status].url,
                    size: new this.google.maps.Size(40, 40),
                    scaledSize: new this.google.maps.Size(40, 40),
                    origin: new this.google.maps.Point(0, 0),
                    anchor: new this.google.maps.Point(20, 40),
                    labelOrigin: new this.google.maps.Point(20, 17),
                    draggable: false,
                },
                zIndex: 1,
            });

            // Define data e hora do início
            let dateHourAux = "";
            if(this.delivery.delivery_end) {
                dateHourAux = '<p class="marker"><b><i class="fa fa-fw fa-people-carry"></i> ' + (this.delivery.status != "failed" ? "Entrega" : "Tentativa de entrega") + ':</b> ' +  this.getDateAndHourFormated(this.delivery.delivery_end) + '</p>';
            }
            
            // Define as informações que aparecerão no popup
            let infowindow = new this.google.maps.InfoWindow({
                content:
                    '<div class="popup">' +
                        '<h3><b>Nº </b> ' +  this.delivery.document_number + '</h3>' +
                        '<h3 class="capitalized"><b>' + this.delivery.customer_name ? this.delivery.customer_name.toLowerCase() : 'Cliente' + '</b></h3>' +
                        '<h4><b><span style="color: ' + status[this.delivery.status].color + '"><i class="fa fa-circle"></i></span> ' + status[this.delivery.status].status + '</b></h4>' +
                        '<p class="marker capitalized"><b><i class="fa fa-fw fa-file-signature"></i> Tipo:</b> ' + (this.delivery.type ? "Pedido" : "Nota Fiscal") + '</p>' +
                        '<p class="marker"><b><i class="fa fa-fw fa-calendar-alt"></i> Data:</b> ' + this.getDateFormated(this.delivery.date) + '</p>' +
                        '<p class="marker"><b><i class="fa fa-fw fa-boxes"></i> Carga:</b> ' + (this.delivery.cargo ? this.delivery.cargo : "Não definida") + '</p>' +
                        '<p class="marker capitalized"><b><i class="fa fa-fw fa-map-marker-alt"></i> Endereço:</b> ' +  this.delivery.street.toLowerCase() + ", " + this.delivery.number.toLowerCase() + " - " + this.delivery.neighborhood.toLowerCase() + '</p>' +
                        '<p class="marker capitalized"><b><i class="fa fa-fw fa-globe-americas"></i> Local:</b> ' +  this.delivery.city.toLowerCase() + ' - ' + this.delivery.uf.toUpperCase() + ', ' + this.delivery.postal_code.replace(/^(\d{5})(\d{3})/, "$1-$2") + '</p>' +
                        dateHourAux +
                    '</div>',
                pixelOffet: new this.google.maps.Point(0, 0),
            });
            
            // abre o popup ao passar o mouse por cima do marcador
            this.google.maps.event.addListener(marker, "mouseover", function() {
                infowindow.open(this.map, marker);
            });
            
            // Fecha o popup ao retirar o mouse de cima do marcador
            this.google.maps.event.addListener(marker, "mouseout", function() {
                infowindow.close(this.map, marker);
            });

			this.delivery.marker = marker;
			this.delivery.infowindow = infowindow;
        },
		
		/**
		 * Adiciona o marcador do ponto de evidência
		 **/
        createEvidencePositionMarker: function() {
			if (this.evidences.length > 0) {
				this.evidences.forEach(evidence => {
					if (evidence.exist_file && evidence.location != null ) {
						// Determina o marcador da posiçaõ do APP e coloca no mapa
						let marker = new this.google.maps.Marker({
							position: {
								lat: parseFloat(evidence.location.split(",")[0]),
								lng: parseFloat(evidence.location.split(",")[1]),
							},
							map: this.map,
							icon: {
								url: evidence_marker,
								size: new this.google.maps.Size(10, 10),
								scaledSize: new this.google.maps.Size(10, 10),
								origin: new this.google.maps.Point(0, 0),
								anchor: new this.google.maps.Point(5, 10),
								labelOrigin: new this.google.maps.Point(10, 4),
								draggable: false,
							},
							zIndex: 2,
						});

						// Define data e hora do início
						let dateHourAux = "";
						if(evidence.date) {
							dateHourAux = evidence.date;
						}
						
						// Define as informações que aparecerão no popup
						let infowindow = new this.google.maps.InfoWindow({
							content:
								'<div class="popup">' +
									'<div style="overflow: hidden; border: 1px solid #ccc; border-radius: 5px; height: 200px; width: 200px;">' +
										'<img src=' + evidence.thumb + ' style="position: relative; width: 100%;" />' +
									'</div>' +
									'<p class="marker">' + dateHourAux + '</p>' +
								'</div>',
							pixelOffet: new this.google.maps.Point(0, 0),
						});
						
						// abre o popup ao passar o mouse por cima do marcador
						this.google.maps.event.addListener(marker, "mouseover", function() {
							infowindow.open(this.map, marker);
						});
						
						// Fecha o popup ao retirar o mouse de cima do marcador
						this.google.maps.event.addListener(marker, "mouseout", function() {
							infowindow.close(this.map, marker);
						});
						
						// Guarda o marcador
						evidence.marker = marker;
						evidence.infowindow = infowindow;
					}
				});
			}
        },

        // Retorna o status do pedido
		getStatus: function(current_status) 
		{
			return status[current_status].status;
		},
		
		// Retorna a cor do status do pedido
		getStatusColor: function(current_status) 
		{
			return status[current_status].color;
		},

		// Retorna a data formatada
		getDateFormated: function(date) 
		{
			return date.split("-").reverse().join("/");
		},
		
		// Retorna a data e horário formatados
		getDateAndHourFormated: function(data) 
		{
			let date = new Date(data);
			return date.toLocaleString();
		},
		
		// Atualiza o centro do mapa
		onClick: function(id, position) 
		{
			// Determina a coordenada
			let coordinates = {
				lat: parseFloat(position.split(",")[0]),
				lng: parseFloat(position.split(",")[1]),
			};

			// Centraliza o mapa
			this.map.setCenter(new this.google.maps.LatLng(coordinates.lat, coordinates.lng));

			// Define o zoom do mapa
			this.map.setZoom(20);
			
			this.delivery.marker.setZIndex(1);
			this.delivery.infowindow.close(this.map, this.delivery.marker);

			this.evidences.forEach(evidence => {
				if (evidence.id == id) {
					if (evidence.marker && evidence.infowindow) {
						evidence.marker.setZIndex(3);
						evidence.infowindow.open(this.map, evidence.marker);
					}
				} else {
					if (evidence.marker && evidence.infowindow) {
						evidence.marker.setZIndex(2);
						evidence.infowindow.close(this.map, evidence.marker);
					}
				}
			});
		},

		// Atualiza o centro do mapa para a posição do motorista
		onClickDelivery: function() 
		{
			// Centraliza o mapa
			this.map.setCenter(new this.google.maps.LatLng(this.center.lat, this.center.lng));

			// Define o zoom do mapa
			this.map.setZoom(16);
			
			this.delivery.marker.setZIndex(3);
			this.delivery.infowindow.open(this.map, this.delivery.marker);

			this.evidences.forEach(evidence => {
				evidence.marker.setZIndex(2);
				evidence.infowindow.close(this.map, evidence.marker);
			});
		},

		/**
         * Prepara o arquivo de download
         * @param {File} data objeto de informações
         */
		download(source, filename) {
            if(source, filename) {
                var encodedUri = encodeURI(source);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", this.delivery.document_number + "_" + this.delivery.date + "_" + filename);
                document.body.appendChild(link);
                link.click();
            }
        },
	}
}
</script>

<style scoped>
.map {
	position: static;
    width: 100%;
	height: calc(100vh - 159px);
    border: none;
	z-index: 1;
}

.control {
	position: absolute;
	box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
	padding: 10px;
	background-color: #fff;
	color: #666;
	z-index: 3;
	border-radius: 2px;
	cursor: pointer;
}

.control-delivery {
	position: fixed;
	top: 140px;
	right: 45px;
}

.evidence-info {
    position: fixed;
	top: 142px;
	margin-left: 10px;
    width: 370px;
	background: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
	z-index: 3;
}

.evidence-info-image {
	overflow: hidden;
	margin: 5px 0px;
	border: 1px solid #ccc;
	border-radius: 5px;
	height: 80px;
	background-color: #eee;
	cursor: pointer;
}

.evidence-info-image-img > img {
	width: 100%;
	height: 100%;
}

.evidence-info-image-label {
	position: absolute;
	color: rgba(255,255,255,.8);
}

.evidence-info-head {
    width: 100%;
    overflow: hidden;
	border-top-left-radius: 2px;
	border-top-right-radius: 2px;
	border-bottom: 1px solid #cdcdcd;
	background-color: #eee;
	padding: 10px;
	font-weight: bold;
}

.evidence-info-name {
	padding-bottom: 5px;
	text-align: center;
	font-size: 14px;
	border-bottom: 1px solid #cdcdcd;
}

.evidence-info-summary {
	text-align: center;
	font-size: 12px;
}

.evidence-info-summary-icon {
	font-size: 20px;
	margin-top: 10px;
	margin-bottom: 10px;
}

.evidence-info-list {
    border-bottom: 1px solid #eee;
}

.evidence-info-body-tab {
	background: #eee;
	border: 1px solid #eee;
	border-bottom: none;
	padding: 10px 15px;
	margin-right: 5px;
	font-weight: bold;
    margin-bottom: -1px;
}

.evidence-info-body-tab.enabled {
	background: #fff;
}

.evidence-info-body-tab-block {
	display: show;
}

.evidence-info-body {
	float: left;
    width: 100%;
	border-bottom-left-radius: 2px;
	border-bottom-right-radius: 2px;
	overflow-y: auto;
	max-height: calc(100vh - 300px);
	background-color: #cdcdcd;
}

.evidence-info-item {
	position: relative;
    padding: 10px 0px;
    float: left;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
}

.evidence-info-item.evidence-info-item-name,
.evidence-info-item.evidence-info-item-license-plate,
.evidence-info-item.evidence-info-item-cargo {
	padding: 5px 0px;
	border-bottom: none;
}

.evidence-info-item.evidence-info-item-name {
	font-size: 14px;
	text-align: center;
}

.evidence-info-left {
    width: 50%;
    float: left;
    font-size: 12px;
    font-weight: bold;
	display: grid;
    align-content: center;
}

.evidence-info-right {
    width: 50%;
    float: right;
    text-align: right;
    font-size: 12px;
}

.evidence-item {
	width: 100%;
	float: left;
	border-bottom: 1px solid #ccc;
	background-color: #fff;
}

.evidence-item:last-child {
	margin-bottom: 0px;
}

.evidence-info-body-tab-block.show {
	display: block;
}

.text-center {
	text-align: center;
}

.button-edit {
	width: 100%;
}

.button-location {
	display: inline;
	background:#005ef7;
	color: #fff;
	font-size: 12px;
	padding: 4px 10px;
	border-radius: 4px;
	text-decoration: none;
	border: none;
}

.button-download {
	display: inline;
	background: #222;
	color: #fff;
	font-size: 12px;
	padding: 4px 10px;
	border-radius: 4px;
	text-decoration: none;
	border: none;
}
</style>